/**
 * Colaboração (spec 02 §1.10 · spec 03 §2 · passo 7.1b).
 *
 * O corpo é HTML de um vocabulário FECHADO, validado pelo servidor. Ele preserva o
 * editor rico do protótipo sem aceitar script, estilo ou atributo arbitrário. Menções
 * carregam o uuid no próprio marcador; o servidor deriva `mencoes`, em vez de confiar
 * num segundo array que poderia discordar do texto publicado.
 */
import { z } from 'zod'
import { uuid } from './comum.js'
import { referenciaDeUsuario } from './usuarios.js'

export const entidadeComentavel = z.enum([
  'empresa',
  'contato',
  'negocio',
  'pedido_venda',
  'campanha',
  'capacidade_fornecedor',
  'colaborador',
  'tarefa',
])
export type EntidadeComentavel = z.infer<typeof entidadeComentavel>

/** O autor e as menções: usuários internos, com a foto (PK-04). */
export const autorDeComentario = referenciaDeUsuario
export type AutorDeComentario = z.infer<typeof autorDeComentario>

export const comentario = z.object({
  id: uuid,
  entidadeTipo: entidadeComentavel,
  entidadeId: uuid,
  autor: autorDeComentario,
  corpo: z.string(),
  mencoes: z.array(autorDeComentario),
  criadoEm: z.string(),
  editadoEm: z.string().nullable(),
  podeEditar: z.boolean(),
  podeExcluir: z.boolean(),
})
export type Comentario = z.infer<typeof comentario>

export const entradaDeComentario = z.object({
  corpo: z.string().trim().min(1).max(20_000),
})
export type EntradaDeComentario = z.infer<typeof entradaDeComentario>

export const listaDeComentarios = z.object({ dados: z.array(comentario) })
export type ListaDeComentarios = z.infer<typeof listaDeComentarios>
